import { initialData } from './initialData';

export function getStorageItem<T>(key: string, defaultValue: T): T {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function setStorageItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving to localStorage:`, error);
  }
}

export function initializeData(): void {
  // Initialize with demo data if not exists
  Object.entries(initialData).forEach(([key, value]) => {
    if (!localStorage.getItem(key)) {
      setStorageItem(key, value);
    }
  });
}